
  import { Vue, Component, Prop } from "vue-property-decorator";
  import SearchableDocumentsList from "@/components/documents/SearchableDocumentsListProjects.vue";
  import { Project, User } from "@/generated/graphql";
  import UploadDocument from "@/components/documents/UploadDocumentNew.vue";

  @Component({
    components: {
      SearchableDocumentsList,
      UploadDocument
    },
  })
  export default class Documents extends Vue {
    @Prop({ type: Object, required: true }) readonly project!: Project;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
     @Prop({ type: String, required: true }) readonly contractorUserId!: string;
    @Prop({ type: String, required: true }) readonly contractorFullName!: string;
    @Prop({ type: String, required: true }) readonly companyId!: string;

    get query(): Record<string, any> {
      return {
        document_projects: {
          project_id: {
            _eq: this.project.id,
          },
         
        },
         uploaded_by: {
						_eq: this.currentUser.id,
					},
      };
    }
  }
